import { fromJS } from "immutable";

const initClientUserData = fromJS([]);

const initFilterClientUser = fromJS({
  clientCode: "",
  // clientName: "",
  pageNo: 1,
  pageSize: 10,
});

export function filterClientUser(state = initFilterClientUser, action) {
  switch (action.type) {
    case "FILTER_SET_CLIENT_USER_CODE_SUCCESS":
      return state.set("clientCode", action.clientCode);
    // case "FILTER_SET_CLIENT_USER_NAME_SUCCESS":
    //   return state.set("clientName", action.clientName);
    case "FILTER_SET_PAGE_NO_SUCCESS":
      return state.set("pageNo", action.pageNo);
    case "FILTER_SET_PAGE_SIZE_SUCCESS":
      return state.set("pageSize", action.pageSize);
    default:
      return state;
  }
}

export function clientUserData(state = initClientUserData, action) {
  switch (action.type) {
    case "CLIENT_USER_FETCH_DATA_SUCCESS":
      return fromJS(action.dataClientUser);
    default:
      return state;
  }
}
